import {
    IInsuraceProduct,
    IInsuranceOrder,
    ISubscriptionError,
} from "StateInterface";
import {Actions} from "insurance/actions";
import {getSubProducts, sortAvailableProducts} from "insurance/utils";

export interface IState {
    insuranceProducts: IInsuraceProduct[];
    insuranceOrders: IInsuranceOrder[];
    isInsuranceSubscribed: boolean;
    showSubscriptionErrorMessage: boolean;
    loading: boolean;
    insuranceBase64Document: string;
    insuranceProductResponse: string;
    insuranceOrderResponse: string;
    subProduct: object;
    selectedSubProduct: string;
    isIndividualSelected: boolean;
    selectedProductIndex: number;
    razorpayUrl: string;
    insuranceDocMsg: string;
    subscriptionError: ISubscriptionError;
    userInputDetails: any;
}

const defaultState: IState = {
    insuranceProducts: null,
    insuranceOrders: null,
    isInsuranceSubscribed: false,
    loading: false,
    showSubscriptionErrorMessage: false,
    insuranceBase64Document: null,
    insuranceProductResponse: null,
    insuranceOrderResponse: null,
    subProduct: {},
    selectedSubProduct: "",
    isIndividualSelected: false,
    selectedProductIndex: null,
    razorpayUrl: "",
    insuranceDocMsg: "",
    subscriptionError: null,
    userInputDetails: null,
};

export default function insurance(state = defaultState, action) {
    switch (action.type) {
        case Actions.REQUEST_INSURANCE_PRODUCTS:
            return {
                ...state,
                loading: true,
            };
        case `${Actions.REQUEST_INSURANCE_PRODUCTS}_SUCCESS`:
            return {
                ...state,
                insuranceProducts: sortAvailableProducts(action.body.products),
                subProduct: getSubProducts(action.body.products),
                loading: false,
                insuranceProductResponse: "SUCCESS",
            };
        case `${Actions.REQUEST_INSURANCE_PRODUCTS}_FAILURE`:
            return {
                ...state,
                loading: false,
                insuranceProductResponse: "FAILURE",
            };
        case Actions.REQUEST_USER_INSURANCE_ORDERS:
            return {
                ...state,
                loading: true,
            };
        case `${Actions.REQUEST_USER_INSURANCE_ORDERS}_SUCCESS`:
            return {
                ...state,
                loading: false,
                insuranceOrders: action.body.orders,
                insuranceOrderResponse: "SUCCESS",
            };
        case `${Actions.REQUEST_USER_INSURANCE_ORDERS}_FAILURE`:
            return {
                ...state,
                loading: false,
                insuranceOrderResponse: "FAILURE",
            };
        case Actions.REQUEST_SUBSCRIBE_INSURANCE:
            return {
                ...state,
                loading: true,
                subscriptionError: null,
            };
        case `${Actions.REQUEST_SUBSCRIBE_INSURANCE}_SUCCESS`:
            return {
                ...state,
                isInsuranceSubscribed: action.body.status,
                razorpayUrl: action.body.url,
                loading: true,
                subscriptionError: null,
            };
        case `${Actions.REQUEST_SUBSCRIBE_INSURANCE}_FAILURE`:
            return {
                ...state,
                loading: false,
                subscriptionError: {status: true, msg: action.body.errors},
            };
        case Actions.CLEAR_SUBSCRIPTION_ERROR:
            return {
                ...state,
                subscriptionError: null,
            };
        case Actions.REQUEST_INSURANCE_DOCUMENT:
            return {
                ...state,
                loading: true,
                insuranceDocMsg: "",
            };
        case `${Actions.REQUEST_INSURANCE_DOCUMENT}_SUCCESS`:
            return {
                ...state,
                loading: false,
                insuranceBase64Document: action.body,
                insuranceDocMsg: "",
            };
        case `${Actions.REQUEST_INSURANCE_DOCUMENT}_FAILURE`:
            return {
                ...state,
                loading: false,
                insuranceDocMsg: "Your policy not yet generated, mail us for more details",
        };
        case Actions.PRODUCT_FROM_SESSION_STORAGE:
            const ins: IState = action.body.insuranceState;
            return {
                ...state,
                selectedSubProduct: ins.selectedSubProduct,
                selectedProductIndex: ins.selectedProductIndex,
                userInputDetails: ins.userInputDetails,
            };
        case Actions.SAVE_USER_INFO:
            return {
                ...state,
                userInputDetails: action.body,
            };
        case Actions.CLEAR_INSURANCE_DOC:
            return {
                ...state,
                insuranceBase64Document: null,
            };
            case Actions.CLEAR_SELECTED_INFO:
            return {
                ...state,
                razorpayUrl: null,
                subscriptionError: null,
            };
        case Actions.INSURANCE_PURCHASED:
            return {
                ...state,
            };
        case Actions.SELECTED_SUB_PRODUCT:
            return {
                ...state,
                selectedSubProduct: action.body.subProduct,
            };
        case Actions.SELECTED_COVER_TYPE:
            return {
                ...state,
                isIndividualSelected: action.body.isIndividualSelected,
            };
        case Actions.SELECTED_PRODUCT:
            return {
                ...state,
                selectedProductIndex: action.body.productIndex,
            };
        case Actions.CLEAR_DOWNLOAD_POLICY_MSG:
            return {
                ...state,
                insuranceDocMsg: "",
            };
            case Actions.SET_INSURANCE_LOADING:
            return {
                ...state,
                loading: action.body,
            };
        default:
            return state;
    }
};
